// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__gs6qh","colMaxWidth":"Table_colMaxWidth__3VniY"};